<template lang="html">
  <div id="video-page" class="d-flex flex-row align-items-center justify-content-center" :class="{ 'menu-active': menuActive }">
    <video autoplay loop src="/static/video/video.mp4"></video>
    <div class="close_btn position-absolute" @click="closeVideo()">
      <i class="fal fa-times-circle"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      menuActive: state => state.ui.menuActive
    })
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady',
      setMenuActive: 'ui/setMenuActive'
    }),
    closeVideo() {
      console.log('?');
      // this.setMenuActive(true);
      this.$router.replace('/neighbourhood');
    }
  },
  mounted() {

    this.setPageReady(true);
  },
  beforeDestroy() {
    window.modelReady = null;
    window.discoverLabelClicked = null;
    window.triggerResize = null;
    this.setPageReady(false);
  },
  components: {
  }
};
</script>

<style lang="scss" scoped>
#video-page {
  padding-top: 0;
  background-color: black;
  position: fixed !important;
  z-index: 9999;
  height: 100%;

  &.menu-active {
    z-index: 0;
  }

  video {
    width: 100%;
    height: auto;
  }

  .close_btn {
    bottom: 20px;
    right: 40px;
    cursor: pointer;

    i {
      font-size: 3rem;
      color: #E0E0E0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VideoPage/VideoPage.vue